import { Component } from '@verndale/core';
import addFormLabelsPlaceholder from '../helpers/addFormLabelsPlaceholder';
import setupPhoneInput from '../helpers/setupPhoneInput';
import checkDropdowns from '../helpers/checkDropdowns';

class ContentDetailGatedForm extends Component {
  setupDefaults() {
    this.dom = {
      heroBackgroundContainer: this.el.querySelector(
        '.content-detail__hero-background'
      ),
      heroContentContainer: this.el.querySelector('.content-detail-hero')
    };
    this.updateHeroBackgroundHeight();
    addFormLabelsPlaceholder(this.el);
    setupPhoneInput(this.el);
    checkDropdowns(this.el);
  }

  addListeners() {
    window.addEventListener('load', this.updateHeroBackgroundHeight.bind(this));
    window.addEventListener(
      'resize',
      this.updateHeroBackgroundHeight.bind(this)
    );
  }

  updateHeroBackgroundHeight() {
    const contentHeight = this.dom.heroContentContainer.offsetHeight;
    this.dom.heroBackgroundContainer.style.height = `${contentHeight}px`;
  }
}

export default ContentDetailGatedForm;
